import React, { useEffect, useReducer } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import * as actions from '../../actions/siteDetails'
import siteReducer from '../../reducers/siteDetails'
const initialState = { quickLinkInfo: null }

const QuickLink = props => {
    const { category, site } = useParams()
    const navLinkurl = useNavigate()
    const [state, dispatch] = useReducer(siteReducer, initialState)
    const { quickLinkInfo } = state
    const renderQuicklink = (tier) => {
        if (tier !== 0)
            return true
        return false;
    }
    useEffect(() => { actions.getUserData(dispatch, site) }, [])

    useEffect(() => { actions.getQuickLinkInfo(dispatch, `?siteid=${site}`) }, [])

    useEffect(() => {
        if (quickLinkInfo) {
            (renderQuicklink(quickLinkInfo.tier) === true)
                ? navLinkurl(`/${category}/${quickLinkInfo.sbg}/${quickLinkInfo.site}/${quickLinkInfo.tier}`)
                : navLinkurl(`/error/${quickLinkInfo.site}`);
        }
    }, [quickLinkInfo])

    return <div>Loading....</div>
}
export default QuickLink